export default {
  getUserinfo: state => state.userinfo,
  getMenuIndex: state => state.menuIndex,
};